import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubjectOfferingService {

  private baseUrl = environment.apiUrl + '/v1/subject-offerings';

  constructor(private http: HttpClient) {}

  getAll(page = 0, size = 10) {
    return this.http.get(`${this.baseUrl}?page=${page}&size=${size}`);
  }

  createOffering(payload: any) {
    return this.http.post(this.baseUrl, payload);
  }

  updateOffering(payload: any) {
    return this.http.put(this.baseUrl, payload);
  }

  deleteOffering(id: number) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  assignTeacher(offeringId: number, assignedTeacherId: number) {
    return this.http.patch(
      `${this.baseUrl}/${offeringId}/assign-teacher`,
      { assignedTeacherId }
    );
  }

  getTopics(offeringId: number) {
    return this.http.get(`${this.baseUrl}/${offeringId}/topics`);
  }

  createTopic(offeringId: number, payload: any) {
    return this.http.post(`${this.baseUrl}/${offeringId}/topics`, payload);
  }

  updateTopic(offeringId: number, payload: any) {
    return this.http.put(`${this.baseUrl}/${offeringId}/topics`, payload);
  }

  deleteTopic(offeringId: number, topicId: number) {
    return this.http.delete(`${this.baseUrl}/${offeringId}/topics/${topicId}`);
  }
}